<template>
  <div class="osk-error-block">
    <div class="osk-wrapper">
      <template v-if="errorStatus === 404 || (error as CustomHTTPError)?.response?.status === 404 || notFound">
        <div class="osk-error-block__title playfair">
          {{ $t('uikit.errorBlock.404.title') }}
        </div>

        <div class="osk-error-block__description">
          {{ $t('uikit.errorBlock.404.description') }}
        </div>

        <div class="osk-error-block__buttons">
          <UikitButton
            v-for="link in catalogLinks"
            :key="link.href"
            :href="link.href"
            class="osk-error-block__button"
            outline
          >
            {{ link.text }}
          </UikitButton>
        </div>
      </template>

      <template v-else>
        <div
          v-if="title"
          class="osk-error-block__title playfair"
        >
          {{ title }}
        </div>

        <div
          v-if="error && typeof error !== 'boolean' && isShowError"
          class="osk-error-block__description"
        >
          {{ error?.message ?? error }}
        </div>

        <div class="osk-error-block__description">
          {{ $t('uikit.errorBlock.custom.description') }}
          <br>
          <a
            class="osk-link"
            href="#"
            @click.prevent="handleSupport"
          >{{ $t('uikit.errorBlock.custom.support') }}</a>
        </div>

        <div class="osk-error-block__buttons">
          <UIButton
            class="osk-error-block__button"
            type="black-inverted"
            size="m"
            @click="emit('retry')"
          >
            {{ $t('uikit.errorBlock.retryBtn') }}
          </UIButton>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CustomHTTPError } from '@/restAPI/error';

const { t } = useI18n();

const catalogLinks = [
  {
    text: t('uikit.errorBlock.catalogLinks.men'),
    href: '/men',
  },
  {
    text: t('uikit.errorBlock.catalogLinks.women'),
    href: '/women',
  },
  {
    text: t('uikit.errorBlock.catalogLinks.kids'),
    href: '/kids',
  },
  {
    text: t('uikit.errorBlock.catalogLinks.lifestyle'),
    href: '/lifestyle',
  },
];

const props = defineProps<{
  title?: string
  error?: Error | CustomHTTPError | null
  isShowError?: boolean
  notFound?: boolean
}>();

const emit = defineEmits<{
  (e: 'retry'): void,
}>();

// TODO костыль для накста, есть бага ssr с useAsyncData. error становится boolean
const errorStatus = useState<number | null>('errorBlockErrorStatus', () => (props.error as CustomHTTPError)?.response?.status);

function handleSupport() {
  if (!window) return;

  if (window.usedeskMessenger?.open) {
    window.usedeskMessenger.open('chat');
  } else {
    window.open('https://oskelly.ru/info/about', '_blank')?.focus();
  }
}

onUnmounted(() => {
  errorStatus.value = null;
});
</script>

<style scoped lang="scss">
.osk-error-block {
  padding: 72px 0 120px;

  &__title {
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 1px;
    text-align: center;
    color: #333333;
    text-transform: uppercase;
    margin: 0 auto;
    max-width: 560px;

    @media screen and (min-width: 767px) {
      font-size: 34px;
      line-height: 44px;
    }
  }

  &__description {
    margin: 15px auto 0;
    padding: 0;
    font-size: 12px;
    line-height: 20px;
    color: #828282;
    max-width: 560px;
    text-align: center;

    @media screen and (min-width: 767px) {
      margin: 23px auto 0;
      font-size: 14px;
      line-height: 22px;
    }

    @media screen and (min-width: 1024px) {
      margin: 15px auto 0;
    }
  }

  &__buttons {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @media screen and (min-width: 767px) {
      margin-top: 38px;
    }

    @media screen and (min-width: 1024px) {
      margin-top: 18px;
    }
  }

  &__button {
    width: 100%;
    margin-bottom: 16px;

    @media screen and (min-width: 767px) {
      width: auto;
      padding: 0 24px;
      margin: 0 12px;
    }
  }
}
</style>
